



























































import {Component, Prop, Vue} from "vue-property-decorator";
import tokens from "@/authorization/tokens";
import Provider from "@/consoleapi/api/provider";
import Number from "@/consoleapi/api/number";

@Component
export default class NumberLists extends Vue {
    public providers = [];

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    public selectedProvider = {
        id: "",
        name: "",
        prefix: "",
    };

    public numbers = [];

    private number = new Number();

    constructor() {
        super();
        this.number.setBearerToken(this.bearerToken);
    }

    doProvider(event: Event) {
        event;
        if (this.selectedProvider.id != null) {
            this.getNumbers();
        }
    }

    purchaseNumber() {
        this.number.purchase(this.accountId, this.selectedProvider.id)
            .then(response => {
                //console.log(response.data);
                this.getNumbers();
            }).catch(error => {
            //console.log(error.response);
        });
    }

    getNumbers() {
        this.number.get(this.accountId, this.selectedProvider.id).then(response => {
            //console.log(response.data);
            this.numbers = response.data;
        });
    }

    mounted() {
        const provider = new Provider();
        provider.setBearerToken(this.bearerToken);
        provider.get(this.accountId)
            .then(response => {
                //console.log(response.data);
                this.providers = response.data;
            }).catch(error => {
            //console.log(error.response);
        });
    }
}
